<template>
  <div>
    <page-header
      has-return
      :page="pageConfig"
      :actions="pageActionsConfig"
      left-side-class="col-12 col-lg-8"
      right-side-class="col-12 col-lg-4 d-flex align-items-center justify-content-end"
      @onReturn="() => $router.back()"
    />
    <student-info :item="item" />
    <div class="my-3">
      <period-selection
        :completed-period="getIsPeriodFinalizedDate"
        :current-period="getCurrentPeriod"
        :disabled-periods="getDisabledDates"
        :disabled-regular-period="false"
        :initial-period="getInitialPeriod"
        :readonly="readonly"
        :has-extended-academic-year="hasExtendedAcademicYear"
        @input="handleChangePeriod"
      />
    </div>
    <div>
      <register-educational-visit
        class="mt-2"
        :selected-period="selectedPeriod"
        :is-period-finalized="isPeriodFinalized"
        :student-info="studentInfo"
        :visit-types="visitTypes"
      />
    </div>
  </div>
</template>

<script>
// third party libs
import moment from 'moment';

//libs
import PageHeader from 'PageHeader';

// services
import {
  getVisitTypes as _getVisitTypes,
  getIsFinalizedPeriod as _getIsFinalizedPeriod,
  checkForExtendedAcademicYearSchool as _checkForExtendedAcademicYearSchool,
} from '@/services/pei/visit-registry.js';

// child components
import {
  StudentInfo,
  PeriodSelection,
  RegisterEducationalVisit,
} from './components';

export default {
  name: 'Registration',
  components: {
    PageHeader,
    StudentInfo,
    PeriodSelection,
    RegisterEducationalVisit,
  },
  data() {
    return {
      studentInfo: {},
      studentInfoOriginal: {},
      readonly: false,
      visitTypes: [],
      selectedPeriodFiltered: null,
      isPeriodFinalized: false,
      hasExtendedAcademicYear: false,
    };
  },
  computed: {
    item() {
      return this.$route.params;
    },
    pageConfig() {
      return {
        icon: 'fas fa-user-tie',
        title: 'Registro de Visitas',
        routes: ['Inicio', 'PEI', 'Registro de Visitas'],
      };
    },
    pageActionsConfig() {
      return [
        {
          name: 'Certificaciones de Visita',
          icon: 'fa fa-check-circle',
          variant: 'success',
          text: 'Validar Visitas',
          visible: true,
          click: () => {},
        },
      ];
    },
    selectedPeriod() {
      let x = this.selectedPeriodFiltered?.year
        ? this.selectedPeriodFiltered
        : this.studentInfoOriginal.currentPeriod;
      return x;
    },
    selectedPeriodDate() {
      return moment()
        .year(this.selectedPeriod.year)
        .month(this.selectedPeriod.monthNumber - 1)
        .date(1)
        .toDate();
    },
    getCurrentPeriod() {
      return new Date(
        this.selectedPeriod?.year,
        this.selectedPeriod?.monthNumber,
        0
      );
    },
    getIsPeriodFinalizedDate() {
      return this.isPeriodFinalized ? this.selectedPeriodDate : null;
    },
    getDisabledDates() {
      let stopDate = this.currentAcademicYear().toDate;
      var dateArray = [];
      var originalDate = moment(new Date());
      var currentDate = moment(new Date());
      var stopDateVal = moment(stopDate).add(1, 'month');

      while (currentDate < stopDateVal) {
        const fromDay = moment(
          this.studentInfo.effectiveDateFrom,
          'DD/MMM/YYYY'
        ).set('date', 1);
        const toDay = moment(this.studentInfo.effectiveDateTo, 'DD/MMM/YYYY')
          .set('date', 1)
          .add(1, 'month');
        if (!moment(currentDate).isBetween(fromDay, toDay)) {
          dateArray.push(moment(currentDate).toDate());
        } else if (currentDate > originalDate) {
          dateArray.push(moment(currentDate).toDate());
        }
        currentDate = moment(currentDate).add(1, 'month');
      }

      return dateArray;
    },
    getInitialPeriod() {
      const year = this.studentInfoOriginal.initialPeriod
        ? this.studentInfoOriginal.initialPeriod.year
        : this.studentInfoOriginal.initialPeriodInfo?.year;

      const month = this.studentInfoOriginal.initialPeriod
        ? this.studentInfoOriginal.initialPeriod.monthNumber
        : this.studentInfoOriginal.initialPeriodInfo?.monthNumber;

      return new Date(year, month, 0);
    },
  },
  async mounted() {
    this.studentInfo = this.item;
    this.studentInfoOriginal = { ...this.item };
    await Promise.all([
      this.fetchVisitTypes(),
      this.fetchIsFinalizedPeriod(),
      this.fetchCheckForExtendedAcademicYearSchool(),
    ]);
  },
  methods: {
    async handleChangePeriod(periodValue) {
      this.selectedPeriodFiltered = periodValue;
      await this.fetchIsFinalizedPeriod();
    },
    async fetchVisitTypes() {
      this.visitTypes = (await _getVisitTypes()).data;
    },
    async fetchIsFinalizedPeriod() {
      this.isPeriodFinalized = (
        await _getIsFinalizedPeriod({
          academicYearId: this.studentInfo.academicYearId,
          month: this.selectedPeriodDate,
          companyId: this.studentInfo.companyId,
          centerId: this.studentInfo.centerId,
        })
      ).data;
    },
    async fetchCheckForExtendedAcademicYearSchool() {
      this.hasExtendedAcademicYear = (
        await _checkForExtendedAcademicYearSchool(
          this.studentInfo.academicYearId,
          this.studentInfo.studentSieId,
          this.studentInfo.disciplineTypeId ??
            this.studentInfo.disciplineType?.id
        )
      ).data;
    },
  },
};
</script>
